export default "__VITE_ASSET__312f21e6__"